var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLearningAdaptiveCorrect = function SvgLearningAdaptiveCorrect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.25,
    cy: 12,
    r: 11,
    fill: "#2B81FC",
    stroke: "#2B81FC",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1831 8.20382C17.7165 8.73729 17.7165 9.60223 17.1831 10.1357L11.7189 15.5999C11.1854 16.1334 10.3205 16.1334 9.78699 15.5999L7.05489 12.8678C6.52142 12.3343 6.52142 11.4694 7.05489 10.9359C7.58837 10.4024 8.4533 10.4024 8.98678 10.9359L10.7529 12.7021L15.2512 8.20382C15.7847 7.67034 16.6496 7.67034 17.1831 8.20382Z",
    fill: "white"
  })));
};
export default SvgLearningAdaptiveCorrect;